import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type ValidatorResult } from 'ember-changeset-validations';
import {
  validateNumber,
  validatePresence,
} from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

const DAC_7_COUNTRIES = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
];

export const PropertyBasicsValidation = {
  name: customMessageValidator(
    'property_basics_name',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  nickname: customMessageValidator(
    'property_basics_nickname',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  bathrooms: customMessageValidator(
    'property_basics_bathrooms',
    validateNumber({
      allowBlank: true,
      multipleOf: 0.5,
      positive: true,
    }),
  ),

  bedrooms: customMessageValidator(
    'property_basics_bedrooms',
    validateNumber({
      allowBlank: true,
      integer: true,
      positive: true,
    }),
  ),

  beds: customMessageValidator(
    'property_basics_beds',
    validateNumber({
      allowBlank: true,
      integer: true,
      positive: true,
    }),
  ),

  maximumCapacity: customMessageValidator(
    'property_basics_maximum_capacity',
    validateNumber({
      allowBlank: true,
      integer: true,
      positive: true,
    }),
  ),

  registrationNumber: customMessageValidator(
    'property_basics_registration_number',
    function (
      key: string,
      newValue: unknown,
      oldValue: unknown,
      changes: Record<string, unknown>,
      content: Record<string, unknown>,
    ): ValidatorResult {
      const property = content as unknown as ModelRegistry['property'];

      if (!property?.address) {
        return true;
      }

      const { country } = property.address;
      const isRegistrationNumberRequired = DAC_7_COUNTRIES.includes(country);

      if (!isRegistrationNumberRequired) {
        return true;
      }

      return validatePresence({ presence: true, ignoreBlank: true })(
        key,
        newValue,
        oldValue,
        changes,
        content,
      );
    },
  ),
};
